import Cookies from 'js-cookie'
import Qwery from 'qwery'
import { emitter } from './features'

const languages = {
  'abkhaz': 'ab',
  'afar': 'aa',
  'afrikaans': 'af',
  'akan': 'ak',
  'albanian': 'sq',
  'amharic': 'am',
  'arabic': 'ar',
  'aragonese': 'an',
  'armenian': 'hy',
  'assamese': 'as',
  'avaric': 'av',
  'avestan': 'ae',
  'aymara': 'ay',
  'azerbaijani': 'az',
  'bambara': 'bm',
  'bashkir': 'ba',
  'basque': 'eu',
  'belarusian': 'be',
  'bengali': 'bn',
  'bihari': 'bh',
  'bislama': 'bi',
  'bosnian': 'bs',
  'breton': 'br',
  'bulgarian': 'bg',
  'burmese': 'my',
  'catalan; valencian': 'ca',
  'chamorro': 'ch',
  'chechen': 'ce',
  'chichewa; chewa; nyanja': 'ny',
  'chinese': 'zh',
  'chuvash': 'cv',
  'cornish': 'kw',
  'corsican': 'co',
  'cree': 'cr',
  'croatian': 'hr',
  'czech': 'cs',
  'danish': 'da',
  'divehi; dhivehi; maldivian;': 'dv',
  'dutch': 'nl',
  'english': 'en',
  'esperanto': 'eo',
  'estonian': 'et',
  'ewe': 'ee',
  'faroese': 'fo',
  'fijian': 'fj',
  'finnish': 'fi',
  'french': 'fr',
  'fula; fulah; pulaar; pular': 'ff',
  'galician': 'gl',
  'georgian': 'ka',
  'german': 'de',
  'greek, modern': 'el',
  'guaraní': 'gn',
  'gujarati': 'gu',
  'haitian; haitian creole': 'ht',
  'hausa': 'ha',
  'hebrew (modern)': 'he',
  'hebrew': 'he',
  'herero': 'hz',
  'hindi': 'hi',
  'hiri motu': 'ho',
  'hungarian': 'hu',
  'interlingua': 'ia',
  'indonesian': 'id',
  'interlingue': 'ie',
  'irish': 'ga',
  'igbo': 'ig',
  'inupiaq': 'ik',
  'ido': 'io',
  'icelandic': 'is',
  'italian': 'it',
  'inuktitut': 'iu',
  'japanese': 'ja',
  'javanese': 'jv',
  'kalaallisut, greenlandic': 'kl',
  'kannada': 'kn',
  'kanuri': 'kr',
  'kashmiri': 'ks',
  'kazakh': 'kk',
  'khmer': 'km',
  'kikuyu, gikuyu': 'ki',
  'kinyarwanda': 'rw',
  'kirghiz, kyrgyz': 'ky',
  'komi': 'kv',
  'kongo': 'kg',
  'korean': 'ko',
  'kurdish': 'ku',
  'kwanyama, kuanyama': 'kj',
  'latin': 'la',
  'luxembourgish, letzeburgesch': 'lb',
  'luganda': 'lg',
  'limburgish, limburgan, limburger': 'li',
  'lingala': 'ln',
  'lao': 'lo',
  'lithuanian': 'lt',
  'luba-katanga': 'lu',
  'latvian': 'lv',
  'manx': 'gv',
  'macedonian': 'mk',
  'malagasy': 'mg',
  'malay': 'ms',
  'malayalam': 'ml',
  'maltese': 'mt',
  'māori': 'mi',
  'marathi (marāṭhī)': 'mr',
  'marshallese': 'mh',
  'mongolian': 'mn',
  'nauru': 'na',
  'navajo, navaho': 'nv',
  // 'norwegian bokmål': 'nb',
  'nb': 'norwegian',
  'north ndebele': 'nd',
  'nepali': 'ne',
  'ndonga': 'ng',
  'norwegian nynorsk': 'nn',
  'norwegian': 'no',
  'nuosu': 'ii',
  'south ndebele': 'nr',
  'occitan': 'oc',
  'ojibwe, ojibwa': 'oj',
  'old church slavonic, church slavic, church slavonic, old bulgarian, old slavonic': 'cu',
  'oromo': 'om',
  'oriya': 'or',
  'ossetian, ossetic': 'os',
  'panjabi, punjabi': 'pa',
  'pāli': 'pi',
  'persian': 'fa',
  'polish': 'pl',
  'pashto, pushto': 'ps',
  'portuguese': 'pt',
  'quechua': 'qu',
  'romansh': 'rm',
  'kirundi': 'rn',
  'romanian': 'ro',
  'russian': 'ru',
  'sanskrit (saṁskṛta)': 'sa',
  'sardinian': 'sc',
  'sindhi': 'sd',
  // 'northern sami': 'se',
  'samoan': 'sm',
  'sango': 'sg',
  'serbian': 'sr',
  'scottish gaelic; gaelic': 'gd',
  'shona': 'sn',
  'sinhala, sinhalese': 'si',
  'slovak': 'sk',
  'slovene': 'sl',
  'somali': 'so',
  'southern sotho': 'st',
  'spanish; castilian': 'es',
  'sundanese': 'su',
  'swahili': 'sw',
  'swati': 'ss',
  'swedish': 'sv',
  'tamil': 'ta',
  'telugu': 'te',
  'tajik': 'tg',
  'thai': 'th',
  'tigrinya': 'ti',
  'tibetan standard, tibetan, central': 'bo',
  'turkmen': 'tk',
  'tagalog': 'tl',
  'tswana': 'tn',
  'tonga (tonga islands)': 'to',
  'turkish': 'tr',
  'tsonga': 'ts',
  'tatar': 'tt',
  'twi': 'tw',
  'tahitian': 'ty',
  'uighur, uyghur': 'ug',
  'ukrainian': 'uk',
  'urdu': 'ur',
  'uzbek': 'uz',
  'venda': 've',
  'vietnamese': 'vi',
  'volapük': 'vo',
  'walloon': 'wa',
  'welsh': 'cy',
  'wolof': 'wo',
  'western frisian': 'fy',
  'xhosa': 'xh',
  'yiddish': 'yi',
  'yoruba': 'yo',
  'zhuang, chuang': 'za'
}

export function getLanguage(language) {
  let lang = 'english';
  let lang_code = 'en';
  let found = false;

  if (language.indexOf('-') !== -1) {
    language = language.split('-')[0]
  }

  // Hackaround for language accent support given two letter locales
  // Nees to appear in the languages list with the original two letter language code
  if (languages.hasOwnProperty(language) && language.length == 2) {
    language = languages[language]
  }

  language = language.toLowerCase()

  if (languages.hasOwnProperty(language)) {
    lang = language
    lang_code = languages[language]
    found = true
  }

  if (!found) {
    // If not found, it means it's not full language name, but rather a code, so try reverse searching for it
    Object.keys(languages).forEach(function(l) {
      if (languages[l] === language) {
        lang = l
        lang_code = languages[l]
      }
    })
  }

  return {
    language: lang,
    lang_code: lang_code
  }
}

export function debug () {
  // eslint-disable-next-line eqeqeq
  if (Cookies.get('easysize_debug_mode') == 'true') {
    var warn = Function.prototype.bind.call(console.warn, console)
    warn.apply(console, arguments)
  }
}

export function enableDebug () {
  Cookies.set('easysize_debug_mode', true, { expires: 28, secure: true, sameSite: 'strict' })
  return 'EasySize debug enabled'
}

export function compareStringIgnoreCase (str1, str2) {
  try {
    return str1.toLowerCase() === str2.toLowerCase()
  } catch (e) {}

  return false
}

export function subscribe (event, callback) {
  let events = event.split(' ')
  for (var i = 0; i < events.length; i++) {
    emitter.on(events[i], callback)
  };
}

export function _hasClass (elementSelector, className) {
  let element = Qwery(elementSelector)
  if (element && element[0]) {
    return element[0].className.indexOf(className) !== -1
  }

  debug(`[EasySize debug]: Element ${elementSelector} does not exist`)
  return -1
}

export function removeElementsByClassName (className) {
  var elements = document.getElementsByClassName(className)

  // for (var i = 0; i < elements.length; i++) {
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0])
  }
}

export function removeElementsById (className) {
  let element = document.getElementById(className)
  if (element) {
    element.parentNode.removeChild(element)
  }
}

export function parseQueryString (query) {
  if (!query) {
    return {}
  }

  var vars = query.split('&')
  var queryString = {}
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    var key = decodeURIComponent(pair[0])
    var value = decodeURIComponent(pair[1])
    // If first entry with this name
    if (typeof queryString[key] === 'undefined') {
      queryString[key] = decodeURIComponent(value)
      // If second entry with this name
    } else if (typeof queryString[key] === 'string') {
      var arr = [queryString[key], decodeURIComponent(value)]
      queryString[key] = arr
      // If third or later entry with this name
    } else {
      queryString[key].push(decodeURIComponent(value))
    }
  }
  return queryString
}



// WEBPACK FOOTER //
// ./src/js/components/utilities.js